export const PIZZA_ICONS: Record<string, string> = {
  "04 Pedaços": "🍕",
  "08 Pedaços": "🍕",
  "10 Pedaços": "🍕",
  Trem: "🚂",
  "Rodizio 04 pedaços": "🍽️",
  "Rodizio 08 pedaços": "🍽️",
  "Pizza Rodizio Doce": "🍽️",
  "04 Pedaços Doce": "🍫",
  "08 Pedaços Doce": "🍫",
};
